
import { Component, Vue } from 'vue-property-decorator'
import { videoSelectPage } from '@/api'
import { QuestionPageParam } from '@/types/type'
@Component({
    name: 'VideoList'
})
export default class extends Vue {
    private keyWord = this.$route.query.keyWord as string || ''
    private questionParams = new QuestionPageParam()
    private total: number = 0
    private isShowMore = false
    // 详情
    private goDetail(id: string) {
        this.$jump(`/Video/VideoDetail?videoId=${id}`)
    }
    private editData: any[] = []
    private async getBaseSearch() {
        this.questionParams.title = this.keyWord
        let res = await videoSelectPage(this.questionParams)
        this.editData = res.data.list
        this.total = res.data.total
    }
    // 加载更多
    private changePage(page: {
        pageNo: string
    }) {
            this.questionParams.pageNum = Number(page.pageNo)
            this.getBaseSearch()
    }
    created() {
        this.getBaseSearch()
    }
}

